import React, { useState, useEffect } from "react";
import {
  Col,
  Form,
  Row,
  Table,
  // Modal,
  Container,
  // Button,
} from "react-bootstrap";
import moment from "moment";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";

import BasicPagination from "../../Pagination/Pagination";
import { Menu, MenuItem } from "@material-ui/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { settlementSummary, settlementReport } from "../../../store/actions/VendorReports/vendorReportsRestaurant";
import isEmpty from "../../../store/validation/is-Empty";
import InfoToolTip from "../../reusableComponents/InfoTooltipComponent";
import CSVDownloader from "../../reusableComponents/csvDownload/csvDownload";
import { RightSideCountTop } from "../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";

const roles = [0, 1];

const SettlementsVendor = (props) => {
  // console.log(props.match.params.type);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  // const [dateQuery, setDateQuery] = useState({
  //   startDate: moment().format("YYYY-MM-DD"),
  //   endDate: moment().format("YYYY-MM-DD"),
  // });
  const [state, setState] = useState({
    search: "",
  });

  let type = props.match.params.type;
  let id = props.match.params.id;
  let restaurant_id = props.match.params.restaurant_id;

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [search, setSearch] = useState("");
  const userFilter = [
    { title: "Total Amount", disabled: true },
    { title: `Low to High 🠑`, disabled: false },
    { title: "High to Low 🠓", disabled: false },
  ];

  const [showFilter, setShowFilter] = useState(false);

  const [filter, setFilter] = useState({
    location: "",
    search: false,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const onSearchChange = (e) => {

    setState({
      ...state,
      [e.target.name]: e.target.value,
    });

  };

  useEffect((async) => {
    props.settlementSummary(props.auth.user.accessToken);
    props.settlementReport(id, props.auth.user.accessToken, "ORDER");
    // console.log("settlemet",props);
  }, []);

  let tempdata = props?.settlementReports?.data && props?.settlementReports?.data.filter((data) => {
    return (
      data?.order?.order_id.toLowerCase().includes(state.search.toLowerCase())
    )
  });

  const totalComission = (base_amount, comissionCode) => {
    let orderTotal = base_amount;
    let percent = parseFloat(comissionCode?.description || 0);
    let comission = (orderTotal * percent) / 100;
    let gst = (comission * 18) / 100
    return (comission + gst).toFixed(2)
  }


  const downloadData = {
    headers: [
      { label: "Restaurant Name", key: "name" },
      { label: "ID", key: "id" },
      { label: "Tip Amount", key: "tip" },
      { label: "Order Amount", key: "order" },
      { label: "Event Amount", key: "event" },
      { label: "Scan Amount", key: "scan" },
      { label: "Total Amount", key: "total" },
    ],
    data: props?.settlementReports?.data
      ? props?.settlementReports?.data?.map(() => {
        return {
          // name: ele?.restaurant_name,
          // id: ele?._id,
          // tip: ele?.totalTip.toFixed(2),
          // order: ele?.totalOrder.toFixed(2),
          // event: ele?.totalEvent.toFixed(2),
          // scan: ele?.totalScan.toFixed(2),
          // total: (
          //   ele?.totalTip +
          //   ele?.totalOrder +
          //   ele?.totalEvent +
          //   ele?.totalScan
          // ).toFixed(2),
        };
      })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation backButtonLink={`/mainsettlementsvendor`} leftText="vendorReview" displayText="Back"
            />
            <Container fluid>
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-4 ">
                  <div className="f24_700_HelveticaNeue">
                    Settlement Reports
                  </div>
                </div>
                <hr />
                <RightSideCountTop
                  content={[
                    {
                      name: "Amount to be Paid",
                      value: `₹ ${props?.settlementReports?.data?.[0]?.settlement_amount}`,
                      backgroundColor: "#EFEBFB",
                      color: "#6F32C9",
                    },
                    {
                      name: "Total Tip Amount",
                      value: `₹ ${props?.settlementReports?.stats?.[0]?.totalTip}`,
                      backgroundColor: "#D8F3F4",
                      color: "#138B90",
                    },
                    {
                      name: "Current Settlement",
                      value: `₹ ${props?.settlementReports?.data?.[0]?.settlement_amount}`,
                      backgroundColor: "#FFEDE9",
                      color: "#EE3A23",
                    },
                    {
                      name: "Comission",
                      value: `₹ ${totalComission(props?.settlementReports?.stats?.[0]?.totalNet, props?.restaurant?.comissionCode)}`,
                      backgroundColor: "#EFEBFB",
                      color: "#6F32C9",
                    },
                    {
                      name: "Credit Memo",
                      value: `₹ ${'0'}`,
                      backgroundColor: "#D8F3F4",
                      color: "#138B90",
                    },
                    {
                      name: "Debit Memo",
                      value: `₹ ${'0'}`,
                      backgroundColor: "#FFEDE9",
                      color: "#EE3A23",
                    }
                  ]}
                />
                <Row className="align-items-center">
                  <Col md={7}>
                    <div className="row super-admin-toptext-searchbar-icon">
                      <div className="col-6">
                        <div className="col-12 p-0">
                          <Form.Control
                            type="text"
                            placeholder="Search"
                            onChange={(e) => setSearch(e.target.value)}
                            value={search}
                            className="amSearch w-100"
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={3}></Col>
                  <div className="col-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <div
                        className="f10-400"
                        align="center"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                      >
                        <img
                          src={require("../../../assets/images/iconButton/sorticon.png")}
                          width="35px"
                          alt="sorticon"
                        />
                        <br />
                        Sort
                      </div>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        {userFilter.map((ele, index) => {
                          return (
                            <MenuItem
                              value={ele.title}
                              key={index}
                              onClick={() => setSort(ele.title)}
                              disabled={ele.disabled}
                            >
                              {ele.title}
                            </MenuItem>
                          );
                        })}
                      </Menu>
                      <div className="f10-400" align="center">
                        <img
                          src={require("../../../assets/images/iconButton/filtericon.png")}
                          width="35px"
                          alt="Filter Icon"
                          onClick={() => setShowFilter(!showFilter)}
                        />
                        <br />
                        Filter
                      </div>
                      <CSVDownloader
                        filename={"statement"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                    </div>
                  </div>
                </Row>
                <hr />
                <div>
                  <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                    <Table>
                      <thead>
                        <tr>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Order Type/ <br />
                            Order ID
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Subtotal <br /> Of Items
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Discount
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Net Order <br /> Value
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Taxes
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Surcharges
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Tip
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Amount <br />Paid
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Outgoing <br /> Charges + GST
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Commission <br />+ GST
                          </th>
                          <th
                            style={{ width: "12%" }}
                            className="f12-500"
                          >
                            Amount to<br /> be Settled
                          </th>
                        </tr>
                      </thead>
                      {tempdata &&
                        tempdata?.map((orderDetails, index) => (
                          <TableBody
                            orderData={orderDetails.order}
                            comissionCode={props.restaurant?.comissionCode}
                            key={index}
                            loader={props.auth.loader}
                          />
                        ))}
                    </Table>
                  </div>
                </div>
                <div className="p4v2-menu-pagination">
                  <BasicPagination
                    totalRecords={props?.settlementReports?.data?.length}
                    limit={5}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                </div>
              </div>
            </Container>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
};

SettlementsVendor.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  settlemetData: PropTypes.array.isRequired,
  settlementReport: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  settlemetData: state.reports.settlemetReport.data,
  settlementReports: state.reports.settlement_type_report,
  auth: state.auth,
  errors: state.errors.errors,
  restaurant: state.onboarding.restaurantDetails
});

export default connect(mapStateToProps, {
  clear_all_errors,
  settlementSummary,
  settlementReport,
})(SettlementsVendor);


const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const calcTaxes = (data) => {
    let tax = 0;
    if (!isEmpty(data)) {
      tax = Object.values(data).reduce(
        (a, b) => parseFloat(a) + parseFloat(b),
        0
      );
    }
    return tax.toFixed(2);
  };


  const calcTotalPayAmount = (transactionDetails) => {
    let payAmount = 0;
    transactionDetails.forEach((ele) => {
      if (ele.paid && ele.method === 'RAZORPAY' && ele.type === 'PAYMENT') {
        payAmount += ele.amount;
      }
    })
    return payAmount;
  }

  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges = (data?.gatewayCharges?.fee || 0) + (data?.gatewayCharges?.tax || 0);
    let donation = data.donation && data.donation.amount ? data.donation.amount : 0;
    let payAmount = data.settleAmount ? data.settleAmount : data.total_amount;
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges;
      return orderPayAmount;
    }
    else {
      return orderPayAmount;
    }
  }

  const orderComission = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = ((order?.base_amount - (order?.offerSettlement === 'ADMIN' ? 0 : order?.discount?.amount || 0)) * comission) / 100;
    let gst = (value * 18) / 100
    return value + gst;
  }

  const orderComssionDetails = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (((order?.base_amount - (order?.offerSettlement === 'ADMIN' ? 0 : order?.discount?.amount || 0)) * comission) / 100).toFixed(2);
    let gst = ((value * 18) / 100).toFixed(2)
    return { fee: value, gst: gst }
  }


  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className={` cursor enGrayBorderBox sd_body_tr`}
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${props.orderData?.blockSettlement ? "#EE3A23" : "#06A200"
                    }`,
                }}
                onClick={showTr}
              >
                <td style={{ width: "12%" }}>
                  <div className="f12-500 text-break pl-3">
                    {props.orderData && props.orderData.order_type === 0
                      ? "Take Away"
                      : props.orderData && props.orderData.order_type === 1
                        ? "Curb Side"
                        : props.orderData && props.orderData.order_type === 3
                          ? "Dine-In"
                          : "Skip The Line"}
                    <br />
                    {props && props.orderData && props.orderData.order_id}
                  </div>
                </td>
                <td style={{ width: "12%" }}>

                  <div className="f12-500">
                    ₹ {props?.orderData?.base_amount?.toFixed(2) || 0}
                  </div>

                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    - ₹ {props?.orderData?.discount?.amount.toFixed(2) || 0}
                  </div>
                </td>

                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {((props?.orderData?.base_amount || 0) - (props?.orderData?.discount?.amount || 0)).toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 d-flex">
                      ₹{calcTaxes(props.orderData.gstAmount)}
                    </div>
                    <InfoToolTip title={"View the bifurcation of Taxes"} data={props.orderData.gstAmount} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹ {calcTaxes(props.orderData.surCharges)}
                    </div>
                    <InfoToolTip title={"View the bifurcation of Surcharges"} data={props.orderData.surCharges} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.tip?.amount  || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.total_amount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {((props?.orderData?.outgoingCharges?.fee || 0) + (props?.orderData?.outgoingCharges?.tax || 0)).toFixed(2)}
                    </div>
                    <InfoToolTip title={"Outgoing gateway charges + GST"} data={props.orderData.outgoingCharges} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹ {orderComission(props.orderData, props?.comissionCode).toFixed(2)}
                    </div>
                    <InfoToolTip title={"Comission Charges + 18% GST"} data={orderComssionDetails(props.orderData, props?.comissionCode)} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {amountToSettle(props.orderData).toFixed(2)}
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Dispute Id</div>
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">
                          Disputed Amount
                          <div className="mt-3">₹ 0</div>
                        </div>
                        <div className="f12-500">Disputed Items
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">Disputed Status
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">
                          Due Date
                          <div className="mt-3">
                            {moment(props.orderData?.settleAfter).add(1, 'day').format("MM-DD-YYYY")}
                            <br />
                            {moment(props.orderData?.settleAfter).add(1, 'day').format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          No of Items
                          <div className="mt-3">{props?.orderData?.order_items?.length}</div>
                        </div>
                        <div className="f12-500">
                          Offer Type
                          <div className="mt-3">
                            {props?.orderData?.offerSettlement === 'ADMIN' ? 'Amealio Offer' : props?.orderData?.discount?.amount ? "Merchant Offer" : 'N/A'}
                          </div>
                        </div>
                        <div className="f12-500">
                          Order Date
                          <div className="mt-3"> {moment(props.orderData?.createdAt).format("MM-DD-YYYY")}
                            <br />
                            {moment(props.orderData?.createdAt).format("LT")}</div>
                        </div>
                        <div className="f12-500">
                          Payment Block
                          <div className="mt-3">{props?.orderData?.blockReason || "-"}</div>
                        </div>
                        <div className="f10-400 m-2" align="center">
                          <img
                            src={require("../../../assets/images/iconButton/eye.png")}
                            width="35px"
                            alt="icon"
                          />
                          <br />
                          View <br /> Dispute
                        </div>
                        <div className="f10-400 m-2" align="center">
                          <img
                            src={require("../../../assets/images/iconButton/eye.png")}
                            width="35px"
                            alt="icon"
                          />
                          <br />
                          View <br /> Transaction
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

// export default SettlementsVendor;
